// extracted by mini-css-extract-plugin
export default {"container":"select-colored-icon_container__i1si6"};